/* eslint-disable no-nested-ternary */
import React, { useMemo, useState } from 'react'
import { BroadcastAudienceType } from 'types'
import { Col, Form, FormInstance, Row, Select } from 'antd'
import broadcastAudienceOptions from 'data/broadcastAudienceOptions'
import { BroadcastFormValues } from 'component/Broadcast/BroadcastDetails'
import useSingleBroadcast from 'hooks/useSingleBroadcast'

const { Item } = Form

interface Props {
	form: FormInstance<BroadcastFormValues>
	canEditBroadcast: boolean
}

const BroadcastFormAudience: React.FC<Props> = ({ form, canEditBroadcast }) => {
	const { broadcast } = useSingleBroadcast()

	const [audienceType] = useState<BroadcastAudienceType | null>(() =>
		form.getFieldValue('audienceType')
	)

	const audienceTypeLabel = useMemo(
		() =>
			audienceType === 'VIEW_SELECTED'
				? 'Select List'
				: audienceType === 'TAG_SELECTED'
				? 'Select Tag'
				: audienceType === 'IMPORTED_FILE'
				? 'Select File'
				: audienceType === 'INTELLIGENT_AUDIENCE'
				? 'Select Intellgent Audience'
				: 'Select Audience',
		[audienceType]
	)

	return (
		<Row gutter={16}>
			<Col xxl={8} xl={12}>
				<Item
					name='audienceType'
					label='Audience *'
					rules={[
						{
							required: true,
							message: 'Select Audience!',
						},
					]}
					extra={
						<div style={{ marginTop: 10, color: '#000' }}>
							No. of contacts Selected: {broadcast?.contactSelected ?? 0}
						</div>
					}
				>
					<Select
						placeholder='Select Audience'
						options={broadcastAudienceOptions}
						optionFilterProp='label'
						showSearch
						disabled={!canEditBroadcast}
					/>
				</Item>
			</Col>
			<Col xxl={8} xl={12}>
				<Item
					hidden={
						audienceType === null ||
						audienceType === 'ALL_OPTED_IN' ||
						audienceType === 'UPLOAD'
					}
					name='audienceTypeFilter'
					label={audienceTypeLabel}
					rules={[
						({ getFieldValue }) => ({
							validator(_, value) {
								if (
									getFieldValue('audienceType') === 'ALL_OPTED_IN' ||
									getFieldValue('audienceType') === null ||
									getFieldValue('audienceType') === 'UPLOAD'
								) {
									return Promise.resolve()
								}
								if (value?.length > 0 || !!value) {
									return Promise.resolve()
								}

								return Promise.reject(new Error('Please Select Contacts'))
							},
						}),
					]}
				>
					<Select
						placeholder={audienceTypeLabel}
						mode={audienceType === 'TAG_SELECTED' ? 'multiple' : undefined}
						maxTagCount={1}
						optionFilterProp='label'
						showSearch
						disabled={!canEditBroadcast}
					/>
				</Item>
			</Col>
		</Row>
	)
}

export default BroadcastFormAudience
